import { useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { setTime } from 'redux/slices';

const toSeconds = (time) => (time.minutes * 60) + time.seconds;
const fromSeconds = (total) => ({ minutes: Math.floor(total / 60), seconds: total % 60 });

// Cronômetro global da partida: roda em qualquer aba (não só no Marcador) e é calculado pelo
// relógio do sistema, então não atrasa quando o navegador segura os timers em segundo plano.
export function GameClock() {
  const gameStarted = useSelector((state) => state.game.gameStarted);
  const timerPaused = useSelector((state) => state.game.timerPaused);
  const store = useStore();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!gameStarted || timerPaused) return undefined;

    let lastWritten = toSeconds(store.getState().game.time);
    let anchor = Date.now() - (lastWritten * 1000);

    const tick = () => {
      const current = toSeconds(store.getState().game.time);
      // O tempo mudou por fora (ex.: "Zerar cronômetro"): volta a contar a partir dele.
      if (current !== lastWritten) anchor = Date.now() - (current * 1000);
      const elapsed = Math.max(0, Math.floor((Date.now() - anchor) / 1000));
      lastWritten = elapsed;
      if (elapsed !== current) dispatch(setTime(fromSeconds(elapsed)));
    };

    const intervalId = setInterval(tick, 500);
    return () => clearInterval(intervalId);
  }, [gameStarted, timerPaused, store, dispatch]);

  return null;
}
